import type { DeviceRegistrationResponse } from '@dynamic-labs/sdk-api-core';

import { getCore } from '../../../client/core/getCore';
import { getDefaultClient } from '../../../client/defaultClient';
import { UnauthorizedError } from '../../../errors/UnauthorizedError';
import { createApiClient } from '../../apiClient';

export const getRegisteredDevices = async (
  client = getDefaultClient()
): Promise<DeviceRegistrationResponse[]> => {
  const core = getCore(client);
  const apiClient = createApiClient({}, client);

  try {
    const response = await apiClient.listDeviceRegistrations({
      environmentId: core.environmentId,
    });

    return response.deviceRegistrations;
  } catch (error) {
    /**
     * The API will return 401 when no devices are registered when there are no
     * devices registered. We need to handle this case gracefully.
     */
    if (error instanceof UnauthorizedError) {
      return [];
    }

    throw error;
  }
};
